import { render } from "./PError.vue?vue&type=template&id=3ff45635"
import script from "./PError.vue?vue&type=script&lang=js"
export * from "./PError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__